import { render, staticRenderFns } from "./cruise-info.vue?vue&type=template&id=1caac94a&scoped=true"
import script from "./cruise-info.vue?vue&type=script&lang=js"
export * from "./cruise-info.vue?vue&type=script&lang=js"
import style0 from "./cruise-info.vue?vue&type=style&index=0&id=1caac94a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caac94a",
  null
  
)

export default component.exports